import React, { useState } from 'react';
import api from '../services/api';

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', date: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setFormData({ name: '', email: '', phone: '', date: '', message: '' });
    setTimeout(() => setSubmitted(false), 5000);
  };

  const infoItems = [
    { icon: '📍', label: 'Address',  value: '123 Main Street, Toronto, ON M5V 1A1' },
    { icon: '📞', label: 'Phone',    value: '(123) 456-7890'                       },
    { icon: '✉️', label: 'Email',    value: 'info@kingsnoodles.ca'                 },
    { icon: '🕐', label: 'Hours',    value: 'Monday – Sunday: 11:00 AM – 10:00 PM'},
  ];

  const fields = [
    { name: 'name',  label: 'Full Name',      type: 'text'  },
    { name: 'email', label: 'Email Address',  type: 'email' },
    { name: 'phone', label: 'Phone Number',   type: 'tel'   },
    { name: 'date',  label: 'Preferred Date', type: 'date'  },
  ];

  return (
    <div className="bg-ink min-h-screen">

      {/* Hero */}
      <section className="relative h-80 flex items-end overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1600&q=85"
          alt="Contact"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/65 to-ink/10"></div>
        <div className="lattice-pattern absolute inset-0 opacity-[0.04]"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 w-full pb-14">
          <div className="flex items-center gap-4 mb-3">
            <div className="h-px w-8 bg-warm-gold"></div>
            <span className="text-warm-gold text-xs tracking-[0.4em] uppercase">We'd Love to Host You</span>
          </div>
          <h1 className="font-serif text-6xl md:text-7xl text-white leading-none">
            Get In <span className="text-gradient-gold">Touch</span>
          </h1>
        </div>
      </section>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-6 py-28">
        <div className="grid lg:grid-cols-2 gap-20">

          {/* Info + Map */}
          <div>
            <h2 className="font-serif text-4xl text-white mb-10">Visit Us</h2>
            <div className="space-y-6 mb-14">
              {infoItems.map((item, i) => (
                <div key={i} className="flex gap-5 group">
                  <div className="w-12 h-12 border border-white/10 group-hover:border-warm-gold/40 flex items-center justify-center text-xl flex-shrink-0 transition-colors duration-300 bg-ink-card">
                    {item.icon}
                  </div>
                  <div className="pt-1">
                    <div className="text-warm-gold text-xs tracking-[0.3em] uppercase mb-1">{item.label}</div>
                    <div className="text-white/60 text-sm">{item.value}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="relative h-72 bg-ink-card border border-white/8 overflow-hidden flex items-center justify-center">
              <div className="lattice-pattern absolute inset-0 opacity-[0.06]"></div>
              <div className="relative z-10 text-center">
                <div className="text-5xl mb-3 opacity-40">🗺️</div>
                <p className="text-white/25 text-xs tracking-[0.4em] uppercase">Google Maps</p>
              </div>
              <span className="absolute top-3 left-3 w-6 h-6 border-t border-l border-warm-gold/30"></span>
              <span className="absolute top-3 right-3 w-6 h-6 border-t border-r border-warm-gold/30"></span>
              <span className="absolute bottom-3 left-3 w-6 h-6 border-b border-l border-warm-gold/30"></span>
              <span className="absolute bottom-3 right-3 w-6 h-6 border-b border-r border-warm-gold/30"></span>
            </div>
          </div>

          {/* Form */}
          <div>
            <h2 className="font-serif text-4xl text-white mb-10">Reserve a Table</h2>
            {submitted && (
              <div className="mb-8 px-6 py-4 border-l-2 border-warm-gold bg-warm-gold/5 text-warm-gold text-sm">
                ✓  Thank you! We'll confirm your reservation shortly.
              </div>
            )}
            <form onSubmit={handleSubmit} className="space-y-4">
              {fields.map(field => (
                <div key={field.name} className="relative">
                  <input
                    type={field.type}
                    name={field.name}
                    value={formData[field.name]}
                    onChange={handleChange}
                    required
                    placeholder=" "
                    className="w-full bg-ink-card border border-white/10 text-white px-4 pt-7 pb-3 focus:outline-none focus:border-warm-gold/60 transition-colors duration-300 text-sm"
                    style={{ colorScheme: 'dark' }}
                  />
                  <label className="absolute left-4 top-2 text-white/30 text-xs tracking-[0.2em] uppercase pointer-events-none">
                    {field.label}
                  </label>
                </div>
              ))}
              <div className="relative">
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="5"
                  placeholder=" "
                  className="w-full bg-ink-card border border-white/10 text-white px-4 pt-7 pb-3 focus:outline-none focus:border-warm-gold/60 transition-colors duration-300 resize-none text-sm"
                ></textarea>
                <label className="absolute left-4 top-2 text-white/30 text-xs tracking-[0.2em] uppercase pointer-events-none">
                  Message / Special Requests
                </label>
              </div>
              <button
                type="submit"
                className="group w-full bg-imperial-red text-white py-4 text-xs tracking-[0.3em] uppercase font-semibold hover:bg-warm-gold hover:text-ink transition-all duration-300 flex items-center justify-center gap-3"
              >
                Send Reservation Request
                <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
              </button>
              <p className="text-white/20 text-xs text-center pt-2">
                We'll respond within 24 hours to confirm your booking.
              </p>
            </form>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Contact;
